import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg3DCardboard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M43.403 11.25v25.5h-10.9l-3.288-6.34c-1.004-1.936-3.002-3.139-5.215-3.139s-4.211 1.203-5.215 3.139l-3.288 6.34h-10.9v-25.5zm3-3H1.597v31.5h15.724l4.127-7.958c.526-1.014 1.539-1.52 2.552-1.52s2.026.507 2.552 1.52l4.127 7.958h15.724z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.726,
			cy: 23.578,
			r: 4.6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.274,
			cy: 23.578,
			r: 4.6,
			transform: "rotate(-76.714 34.277 23.578)"
		})
	] }) })
});
export default Svg3DCardboard;
